
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDTzcw24FWqbFA6nxcyJDJeLhqY0v7IGlzcn1pLV1QBAMeta } from "/var/www/html/frontend/app/pages/index.vue?macro=true";
import { default as _91id_93WxN03tjtd9B1h7pR2joy8sxGir6MpLwc_45v6CdsyHAP8Meta } from "/var/www/html/frontend/app/pages/form/[id].vue?macro=true";
import { default as indexXSAAKGM4orOVHSabezHAEoE0x083ZUI3EkH3iib4hBQMeta } from "/var/www/html/frontend/app/pages/search/index.vue?macro=true";
import { default as index6SxycynW2Frp_FoBoz9lgOiFV6Xv5YwNFpo9to7coVkMeta } from "/var/www/html/frontend/app/pages/[...slug]/index.vue?macro=true";
import { default as cho9Pw78bly8sRV93RLk9HTjtFg9NmhTcuUg6D4VVGt98Meta } from "/var/www/html/frontend/app/pages/landing-page/ch.vue?macro=true";
import { default as deTnv7H_45PLbWob4pZpeurC0mzCDQeVJ3FZxiU5wQrMIxEMeta } from "/var/www/html/frontend/app/pages/landing-page/de.vue?macro=true";
import { default as indexGLUvT1Le_456saty7EgA9M11srgDDJt5UIw3OmCsvRreQMeta } from "/var/www/html/frontend/app/pages/node/[nid]/index.vue?macro=true";
import { default as groupX__459UjVmICQO0xKCsFc4F_45rqkXgf19evRRk5QTQfeNEMeta } from "/var/www/html/frontend/app/pages/landing-page/group.vue?macro=true";
import { default as hotelFPeSNi1DrZ5A5ckCydLelWJgXagqKEqKtOWt5zfVXG0Meta } from "/var/www/html/frontend/app/pages/landing-page/hotel.vue?macro=true";
import { default as _91id_93jCddYEv9ARv9z0prBryIywCTFpoHpfqedmQUVfQVu00Meta } from "/var/www/html/frontend/app/pages/form/confirmation/[id].vue?macro=true";
import { default as indexnr1L0Kny1rkHkKpxP3krXpfD8lq_YBf_456SAUqrT_4CcMeta } from "/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/:langPrefix(de|fr|en)",
    meta: { ...(indexDTzcw24FWqbFA6nxcyJDJeLhqY0v7IGlzcn1pLV1QBAMeta || {}), ...{"originalName":"home"} },
    component: () => import("/var/www/html/frontend/app/pages/index.vue")
  },
  {
    name: "webform-route",
    path: "/:langPrefix(de|fr|en)/form/:id()",
    meta: { ...(_91id_93WxN03tjtd9B1h7pR2joy8sxGir6MpLwc_45v6CdsyHAP8Meta || {}), ...{"originalName":"webform-route"} },
    component: () => import("/var/www/html/frontend/app/pages/form/[id].vue")
  },
  {
    name: "search___de",
    path: "/de/suche",
    meta: { ...(indexXSAAKGM4orOVHSabezHAEoE0x083ZUI3EkH3iib4hBQMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"search"} },
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    meta: { ...(indexXSAAKGM4orOVHSabezHAEoE0x083ZUI3EkH3iib4hBQMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"search"} },
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: { ...(indexXSAAKGM4orOVHSabezHAEoE0x083ZUI3EkH3iib4hBQMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"search"} },
    component: () => import("/var/www/html/frontend/app/pages/search/index.vue")
  },
  {
    name: "drupal-route",
    path: "/:slug(.*)*",
    meta: index6SxycynW2Frp_FoBoz9lgOiFV6Xv5YwNFpo9to7coVkMeta || {},
    component: () => import("/var/www/html/frontend/app/pages/[...slug]/index.vue")
  },
  {
    name: "landing-page-ch___de",
    path: "/de/schweiz",
    meta: { ...(cho9Pw78bly8sRV93RLk9HTjtFg9NmhTcuUg6D4VVGt98Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-ch"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/ch.vue")
  },
  {
    name: "landing-page-ch___fr",
    path: "/fr/suisse",
    meta: { ...(cho9Pw78bly8sRV93RLk9HTjtFg9NmhTcuUg6D4VVGt98Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-ch"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/ch.vue")
  },
  {
    name: "landing-page-ch___en",
    path: "/en/switzerland",
    meta: { ...(cho9Pw78bly8sRV93RLk9HTjtFg9NmhTcuUg6D4VVGt98Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-ch"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/ch.vue")
  },
  {
    name: "landing-page-de___de",
    path: "/de/deutschland",
    meta: { ...(deTnv7H_45PLbWob4pZpeurC0mzCDQeVJ3FZxiU5wQrMIxEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-de"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/de.vue")
  },
  {
    name: "landing-page-de___fr",
    path: "/fr/allemagne",
    meta: { ...(deTnv7H_45PLbWob4pZpeurC0mzCDQeVJ3FZxiU5wQrMIxEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-de"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/de.vue")
  },
  {
    name: "landing-page-de___en",
    path: "/en/germany",
    meta: { ...(deTnv7H_45PLbWob4pZpeurC0mzCDQeVJ3FZxiU5wQrMIxEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-de"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/de.vue")
  },
  {
    name: "node-canonical",
    path: "/:langPrefix(de|fr|en)/node/:nid()",
    meta: { ...(indexGLUvT1Le_456saty7EgA9M11srgDDJt5UIw3OmCsvRreQMeta || {}), ...{"originalName":"node-canonical"} },
    component: () => import("/var/www/html/frontend/app/pages/node/[nid]/index.vue")
  },
  {
    name: "landing-page-group___de",
    path: "/de/gruppe",
    meta: { ...(groupX__459UjVmICQO0xKCsFc4F_45rqkXgf19evRRk5QTQfeNEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-group"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/group.vue")
  },
  {
    name: "landing-page-group___fr",
    path: "/fr/groupe",
    meta: { ...(groupX__459UjVmICQO0xKCsFc4F_45rqkXgf19evRRk5QTQfeNEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-group"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/group.vue")
  },
  {
    name: "landing-page-group___en",
    path: "/en/group",
    meta: { ...(groupX__459UjVmICQO0xKCsFc4F_45rqkXgf19evRRk5QTQfeNEMeta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-group"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/group.vue")
  },
  {
    name: "landing-page-hotel___de",
    path: "/de/hotel",
    meta: { ...(hotelFPeSNi1DrZ5A5ckCydLelWJgXagqKEqKtOWt5zfVXG0Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-hotel"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/hotel.vue")
  },
  {
    name: "landing-page-hotel___fr",
    path: "/fr/hotel",
    meta: { ...(hotelFPeSNi1DrZ5A5ckCydLelWJgXagqKEqKtOWt5zfVXG0Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-hotel"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/hotel.vue")
  },
  {
    name: "landing-page-hotel___en",
    path: "/en/hotel",
    meta: { ...(hotelFPeSNi1DrZ5A5ckCydLelWJgXagqKEqKtOWt5zfVXG0Meta || {}), ...{"drupalFrontendRoute":true,"originalName":"landing-page-hotel"} },
    component: () => import("/var/www/html/frontend/app/pages/landing-page/hotel.vue")
  },
  {
    name: "webform-confirmation",
    path: "/:langPrefix(de|fr|en)/form/confirmation/:id()",
    meta: { ...(_91id_93jCddYEv9ARv9z0prBryIywCTFpoHpfqedmQUVfQVu00Meta || {}), ...{"originalName":"webform-confirmation"} },
    component: () => import("/var/www/html/frontend/app/pages/form/confirmation/[id].vue")
  },
  {
    name: "press-release-detail___de",
    path: "/de/medien/:slug(.*)*",
    meta: { ...(indexnr1L0Kny1rkHkKpxP3krXpfD8lq_YBf_456SAUqrT_4CcMeta || {}), ...{"originalName":"press-release-detail"} },
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "press-release-detail___fr",
    path: "/fr/communiques-de-presse/:slug(.*)*",
    meta: { ...(indexnr1L0Kny1rkHkKpxP3krXpfD8lq_YBf_456SAUqrT_4CcMeta || {}), ...{"originalName":"press-release-detail"} },
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "press-release-detail___en",
    path: "/en/press-release/:slug(.*)*",
    meta: { ...(indexnr1L0Kny1rkHkKpxP3krXpfD8lq_YBf_456SAUqrT_4CcMeta || {}), ...{"originalName":"press-release-detail"} },
    component: () => import("/var/www/html/frontend/app/pages/press-release/[...slug]/index.vue")
  }
]